import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {ConceptsContainer} from '../../../core/definitions/concepts-container';
import {ConceptService} from '../../../core/concept.service';
import {ConceptDialogService, OpenConceptParams} from '../../admin-concept-lists/concept-dialog.service';

@Component({
    selector: 'app-admin-list-action-toolbar',
    templateUrl: './admin-list-action-toolbar.component.html',
    styleUrls: ['./admin-list-action-toolbar.component.scss'],
    standalone: false
})
export class AdminListActionToolbarComponent {
  // Injections
  private readonly conceptService: ConceptService = inject(ConceptService);
  private readonly conceptDialogService: ConceptDialogService = inject(ConceptDialogService);

  @Input() conceptsContainer: ConceptsContainer;
  @Output() updateConceptList = new EventEmitter<void>();

  async addConcept() {
    const concept = await this.conceptService.createChildConcept(this.conceptsContainer);
    const params: OpenConceptParams = {
      conceptsContainer: this.conceptsContainer,
      concept: concept,
      concept_id: null,
      index: -1,
      callback: (stored: boolean) => {
        if (stored) {
          this.updateConceptList.emit();
        }
      }
    };
    this.conceptDialogService.openConcept(params);
  }

  getConceptsFromKulturNav() {
    this.conceptDialogService.openKulturNavImporter(this.conceptsContainer, (hadImports: boolean) => {
      if (hadImports) {
        this.updateConceptList.emit();
      }
    });
  }

}
